@use '../../scss/utility/functions' as utility;

:host {
  /** @prop --size: the size of the spinner */
  --size: #{utility.wb-pixel-to-rem(32px)};
  /** @prop --circle-color: the circle color of the spinner (used for theming) */
  --circle-color: var(--wb-grey-85);
  /** @prop --circle-highlight-color: the circle highlight color of the spinner (used for theming) */
  --circle-highlight-color: var(--wb-blue-45);

  display: inline-block;
  overflow: visible;
  width: var(--size);
  height: var(--size);

  .inner {
    display: block;
    box-sizing: border-box;
    width: inherit;
    height: inherit;
    border-radius: 100%;
    border-width: utility.wb-pixel-to-rem(2px);
    border-style: solid;
    border-image: initial;
    border-color: var(--circle-highlight-color) var(--circle-color) var(--circle-color);
  }
}

:host(:not([paused])) .inner {
  animation: spinnerAnimation 1s cubic-bezier(0.3, 0.1, 0.25, 0.65) 0s infinite normal none;
}

:host([theme='dark']) {
  --circle-color: var(--wb-grey-40);
  --circle-highlight-color: var(--wb-blue-50);
}

:host([theme='blue']) {
  --circle-color: var(--wb-blue-70);
  --circle-highlight-color: var(--wb-white);
}

@keyframes spinnerAnimation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
